import { render, staticRenderFns } from "./red_talent3.vue?vue&type=template&id=fbeb9c4e&scoped=true"
import script from "./red_talent3.vue?vue&type=script&lang=js"
export * from "./red_talent3.vue?vue&type=script&lang=js"
import style0 from "./red_talent3.vue?vue&type=style&index=0&id=fbeb9c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbeb9c4e",
  null
  
)

export default component.exports